import "@/App.css";
import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Calculator from "./components/Calculator";
import LoginModal from "./components/LoginModal";
import { LOAN_OFFICERS } from "./config/loanOfficers";

function App() {
  const [loanOfficer, setLoanOfficer] = useState(null);

  // Check for saved session on mount
  useEffect(() => {
    const savedOfficer = sessionStorage.getItem('loanOfficer');
    if (savedOfficer) {
      try {
        const parsed = JSON.parse(savedOfficer);
        // Refresh from config so newly added fields (e.g., applicationLink) are always present
        const fresh = parsed?.id && LOAN_OFFICERS[parsed.id]
          ? { ...LOAN_OFFICERS[parsed.id], id: parsed.id }
          : parsed;
        setLoanOfficer(fresh);
        sessionStorage.setItem('loanOfficer', JSON.stringify(fresh));
      } catch (e) {
        sessionStorage.removeItem('loanOfficer');
      }
    }
  }, []);

  const handleLogin = (officer) => {
    setLoanOfficer(officer);
    sessionStorage.setItem('loanOfficer', JSON.stringify(officer));
  };

  const handleLogout = () => {
    setLoanOfficer(null);
    sessionStorage.removeItem('loanOfficer');
  };

  // Show login if not authenticated
  if (!loanOfficer) {
    return <LoginModal onLogin={handleLogin} />;
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Calculator loanOfficer={loanOfficer} onLogout={handleLogout} />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
